import axios from "axios";

export const BASE_PATH = process.env.REACT_APP_VFUN_API_DNS;

//// CombineMenu
export interface ISub_Menu {
  created_at: string;
  menu_code: string;
  target: string;
  target_url: string;
  title: string;
}

export interface IMenuData {
  menu_code: string;
  sub_menu: string;
  sub_menus: ISub_Menu[];
}

export interface ICombineMenu {
  result: number;
  data: IMenuData[];
}

export const getCombineMenu = (
  headers: {
    Ssoinfo: string;
    Userid: string;
    Userbirth: string;
    channelingType: string;
  },
  langCode: string
) =>
  axios
    .get(`${BASE_PATH}/api/vfun/combinemenus?lang=${langCode}`, {
      headers: headers
    })
    .then((res) => res.data);

//// Languages
interface ILangData {
  lang: string;
  lang_code: string;
}

export interface ILang {
  result: number;
  data: ILangData[];
}

export const getLanguage = () =>
  axios.get(`${BASE_PATH}/api/vfun/support_languages`).then((res) => res.data);

//// Banner
// sideMenu 하단의 배너
interface IBannerData {
  idx: number;
  banner_name: string;
  banner_image_url: string;
  banner_hover_image_url: string;
  language: string;
  target: string;
  target_url: string;
  start_date: string;
  end_date: string;
}

export interface IBanner {
  result: number;
  data: IBannerData[];
}

export const getBanner = () =>
  axios
    .get(`${BASE_PATH}/api/vfun/combinemenu_banners`)
    .then((res) => res.data);

interface ITBData {
  banner_image_url: string;
  end_date: string;
  start_date: string;
  language: string;
  target: string;
  target_url: string;
  text: {};
}

// 게시글 리스트 위 배너
export interface ITopBanner {
  data: ITBData[];
  result: number;
}

export const getTopBanner = () =>
  axios.get(`${BASE_PATH}/api/vfunlounges/banner`).then((res) => res.data);

//// LoungeInfo, 라운지 최상단 정보 API
export interface ILoungeInfo {
  result: number;
  msg: string;
  data: {
    service_code: string;
    top_background_image_url: string;
    top_thumb_image_url: string;
    youtube_id: string | null;
    genre: number;
    web_url: string;
    pre_regist_url: string | null;
    age: number;
    sns: string;
    show_flag: string;
    like_count: number;
    title: string;
  };
  user_like_status: number;
}

export const getLoungeInfo = (
  service_code: string,
  headers: {
    Ssoinfo: string;
    Userid: string;
    Userbirth: string;
    channelingType: string;
  },
  lang: string
) =>
  axios
    .get(`${BASE_PATH}/api/vfunlounge/${service_code}?lang=${lang}`, {
      headers: headers
    })
    .then((res) => res.data);

// PageCategory
interface CategoryData {
  admin_flag: number;
  idx: number;
  service_code: string;
  lang_code: string;
  title: string;
}

export interface ILoungeSectionList {
  result: number;
  msg: string;
  data: CategoryData[];
}

export const getLoungeSectionList = (service_code: string) =>
  axios
    .get(`${BASE_PATH}/api/vfunlounge/sections/${service_code}`)
    .then((res) => res.data);

//// 컨텐츠 Api
// notice slide
interface ISlide {
  idx: number;
  section: string;
  title: string;
  lang_code: string;
}

export interface INoticeSlideProps {
  result: number;
  data: ISlide[];
}

export const getNoticeSlide = (service_code: string, lang: string) =>
  axios
    .get(`${BASE_PATH}/api/vfunlounge/posts/${service_code}/top?lang=${lang}`)
    .then((res) => res.data);

// detailcontent
export interface DetailData {
  admin_flag: number;
  admin_icon: string;
  idx: number;
  service_code: string;
  section: number;
  language: string;
  title: string;
  user_nickname: string;
  content: string;
  images: null | string[];
  status: number;
  user_id: string;
  like_count: number;
  created_at: string;
  updated_at: string;
  user_ip: string;
  comments_count: number;
  user_like_status: number;
  profile_image_url_from: string;
  user_Serial_from: number | undefined;
  user_Serial_to: number | undefined;
  user_nickname_from: string;
  user_nickname_to: string;
  user_Serial: number;
  profile_key: string;
}

export interface IDetail {
  result: number;
  msg: string;
  data: DetailData;
}

export const getDetailContent = (
  headers: {
    Ssoinfo: string;
    Userid: string;
    Userbirth: string;
    channelingType: string;
  },
  api: string
) =>
  axios
    .get(api, {
      headers: headers
    })
    .then((res) => res.data);

//// 댓글 관련 Api
export interface CommentData {
  idx: number;
  board_idx: number;
  comment_idx: number;
  comment: string;
  images: string[];
  status: number;
  user_id: string;
  user_ip: string;
  created_at: string;
  updated_at: string;
  admin_flag: number;
  admin_icon: string;
  user_nickname: string;
  user_Serial: number;
  user_profile_key: string;
  profile_image_url_from: string;
}

interface Data {
  current_page: number;
  data: CommentData[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: null | string;
  path: string;
  per_page: number;
  prev_page_url: null | string;
  to: number;
  total: number;
}

export interface IComment {
  result: number;
  data: Data;
}
